import { ref, onMounted, readonly } from 'vue';
import {
  useWindowSize, useEventListener, useDebounceFn, provideLocal, injectLocal,
} from '@vueuse/core';
import { usePageData } from '@composables/usePageData';
import { tablet, desktop, desktopMedium } from '../../constants/breakpoints';

const DEVICE_TYPE_REPOSITORY = Symbol.for('DEVICE_TYPE_REPOSITORY');

export const useDeviceTypeProvide = () => {
  const { deviceType } = usePageData();
  const { width } = useWindowSize();

  const isMobile = ref(deviceType === 'PHONE');
  const isTablet = ref(deviceType === 'TABLET');
  const isDesktop = ref(deviceType === 'DESKTOP');
  const isDesktopMedium = ref(deviceType === 'DESKTOP');

  function updateDevice() {
    isMobile.value = width.value < tablet;
    isTablet.value = width.value >= tablet && width.value < desktop;
    isDesktop.value = width.value >= desktop;
    // TODO: Remove isDesktopMedium (isDesktopMedium and isDesktop are the same on SSR.
    // The isDesktopMedium value is updated only after resizing, which causes flickering
    isDesktopMedium.value = width.value >= desktop && width.value <= desktopMedium;
  }

  const updateDeviceDebounced = useDebounceFn(updateDevice, 100);
  onMounted(() => {
    updateDevice(); // Temporary fix for isDesktopMedium
    useEventListener(window, 'resize', updateDeviceDebounced);
  });

  const toProvide = {
    isMobile: readonly(isMobile),
    isTablet: readonly(isTablet),
    isDesktop: readonly(isDesktop),
    isDesktopMedium: readonly(isDesktopMedium),
  };

  provideLocal(DEVICE_TYPE_REPOSITORY, toProvide);
  return toProvide;
};

export const useDeviceType = () => {
  const deviceType = injectLocal(DEVICE_TYPE_REPOSITORY);

  if (typeof deviceType === 'undefined') {
    throw new TypeError('useDeviceType() is called without provider.');
  }

  return deviceType;
};
